// extracted by mini-css-extract-plugin
export default {"skeleton-loader":"nhZBEtT","gradient":"kDhUosk","skeleton-loader--pill":"a20hFHQ"};